<template>
      <section class="about">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-6 image">
                     <img src="../assets/images/happy-family-dentist.jpeg" class="w-100 mb-5 mb-md-0 rounded-image" alt="Gelukkige familie na tandheelkundige behandeling bij Tandzorg Gestel"> <!-- todo: add image -->
                </div>
                <div class="col-md-6 content">
                  <h2 class="heading about-heading">Over ons</h2>
                    <h3>Complete mondzorg voor het hele gezin</h3>
                    <p>Bij Tandzorg Gestel krijgt uw gezin de zorg die het verdient. Van regelmatige controles en preventieve behandelingen tot vullingen en wortelkanaalbehandelingen wij zorgen voor een gezond en stralend gebit. Uw comfort en welzijn staan altijd voorop.</p>
                    <router-link class="link-btn" to="/over-ons" :style="this.$store.state.activePage == 'AboutUs' ? {'color': '#00b8b8'} : {}" @click="makePageActive('AboutUs');">Lees meer</router-link>
                  </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "AboutSection",
    methods: {
      makePageActive(activepage){
        this.$store.commit('updateActivePage', activepage)
      }
    }
}
</script>

<style scoped>
.about .row {
  min-height: 50vh;
}

.about .image img {
  border-radius: 8px; /* afgeronde hoeken toegevoegd net als gang foto */
}

.about .content .about-heading {
  text-align: left;
  color: var(--black);
  margin-bottom: 1rem;
}
.about .content h3 {
  font-size: 3rem;
  color: var(--black);
  margin-top: 0;
}
.about .content p {
  padding: 1rem 0;
  font-size: 1.4rem;
  color: var(--light-color);
  line-height: 2;
}

.rounded-image {
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* desktop: minder ruimte boven en onder deze sectie */
@media (min-width: 992px) {
  .about {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }
  .about .row {
    min-height: auto;
  }
}

@media (max-width: 768px) {
  .about .row {
    padding: 3rem 0;
  }
}
@media (max-width: 450px) {
  .about .content h3 {
    font-size: 2.3rem;
    margin-top: 0rem;
  }
  .about .content p {
    padding: 0.3rem 0;
    padding-left: 0.2rem;
  }
}
</style>